import { FeatureFlagBooleanValue } from '@feature-flags/feature-flag.service';

export function checkFeatureFlag(configValue: boolean, showIf: FeatureFlagBooleanValue): boolean {
  const show = showIf === 'on';
  return configValue === show;
}
